import { AbstractControl, FormControl, ValidatorFn } from "@angular/forms";

export class UIUtils {
  

  public static calculateWidth(window: Window, percent: number): number {
    return (window.outerWidth * percent) / 100;
  }

  public static calculateHeight(window: Window, percent: number): number {
    return (window.outerHeight * percent) / 100;
  }

}
